// removed by extract-text-webpack-plugin
module.exports = {"LaunchWizard":"LaunchWizard--3lWKR","CardHeader":"CardHeader--3cwP7","aRecords":"aRecords--cMknv","cname":"cname--2etTK"};